import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { resolveOAuthReturnUrl } from '@/lib/navigation/oauth-return-url';
import { gwsAuditLogKey } from '../../../../../accesses/_layout/settings/-gws-audit-log-query/key';
import { SearchSchema } from './-schemas';
export const Route = createFileRoute('/_staff/software/_layout/marketplace/$id/install/finish/')({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({
    search
  }) => ({
    search
  }),
  beforeLoad: async ({
    search,
    context
  }) => {
    const {
      appIntegrationId,
      softwareId
    } = search;
    if (search.result === 'success' && appIntegrationId && softwareId) {
      await context.queryClient.invalidateQueries({
        queryKey: gwsAuditLogKey.config(appIntegrationId)
      });
      const returnUrl = resolveOAuthReturnUrl();
      if (returnUrl) {
        throw redirect({
          href: returnUrl
        });
      }
      throw redirect({
        to: '/software/$id',
        params: {
          id: softwareId
        }
      });
    }
    if (search.result === 'error') {
      // storage を掃除（戻り値は捨てる、副作用の removeItem のみ利用）
      resolveOAuthReturnUrl();
    }
  }
});